import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const COMMITMENTS = [
  {
    heading: 'Flat pricing, no hourly billing',
    detail: 'We quote fixed prices because we think you should know what something costs before you agree to it. Out-of-scope work gets identified and priced upfront, not discovered on the final invoice.',
  },
  {
    heading: 'A real timeline, not "weeks"',
    detail: 'Every project starts with a written schedule. Milestones, revision rounds, and a launch date are agreed before any work begins, so there are no moving targets.',
  },
  {
    heading: 'You own everything',
    detail: "Domain, hosting, source code. All yours from day one. We don't believe in platform lock-in or holding a site hostage to keep a client relationship going.",
  },
  {
    heading: 'Replies within 24 hours',
    detail: 'During active projects, expect a reply the same business day. Outside of that, within 24 hours. We think responsiveness is a basic professional standard, not a premium feature.',
  },
];

function About() {
  return (
    <main className="about-page">

      {/* -------- HERO -------- */}
      <section className="ab-hero">
        <span className="ab-hero-watermark" aria-hidden="true">studio</span>

        <div className="ab-container">
          <p className="ab-eyebrow ab-anim ab-anim-1">
            <span className="ab-eyebrow-rule"></span>
            About the studio
          </p>

          <h1 className="ab-anim ab-anim-2">
            A small studio building <em>considered</em> websites for service businesses.
          </h1>

          <p className="ab-hero-lede ab-anim ab-anim-3">
            We work with founders, practices, and small teams who want a website that's
            clear, calm, and built to last. No platform lock-in. No surprise
            charges. Just websites that do the work they're meant to do.
          </p>

          <p className="ab-hero-pricing ab-anim ab-anim-4">
            Full pricing and scope on the <Link to="/services" className="ab-pricing-link">services page</Link>.
          </p>
        </div>
      </section>

      {/* -------- COMMITMENTS -------- */}
      <section className="ab-section">
        <div className="ab-container">
          <div className="ab-section-header">
            <p className="ab-eyebrow">
              <span className="ab-eyebrow-rule"></span>
              Commitments
            </p>
            <h2>What you can <em>count on</em>.</h2>
            <p>
              Most freelance horror stories come down to the same handful of failures.
              Here's where we've decided to do things differently.
            </p>
          </div>

          <div className="ab-commitments">
            {COMMITMENTS.map((c, i) => (
              <div key={c.heading} className="ab-commitment">
                <span className="ab-commitment-num">{String(i + 1).padStart(2, '0')}</span>
                <div className="ab-commitment-body">
                  <h3>{c.heading}</h3>
                  <p>{c.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* -------- HOW WE WORK -------- */}
      <section className="ab-section ab-section-alt">
        <div className="ab-container">
          <div className="ab-how-grid">
            <div>
              <p className="ab-eyebrow">
                <span className="ab-eyebrow-rule"></span>
                How we work
              </p>
              <h2>Slow enough to <em>think</em>, fast enough to ship.</h2>
            </div>
            <div className="ab-how-text">
              <p>
                Most websites fail because they're rushed. The structure is half-considered,
                the copy is filler, and the design is whatever the template gave the buyer.
                Then everyone wonders why it doesn't convert.
              </p>
              <p>
                We start every project with a kickoff conversation about what your site is
                actually for. Not what pages it should have, but what it should do for the
                people who land on it. Everything after that follows from the answer.
              </p>
              <p>
                Timelines run 3–8 weeks depending on project scope, starting from content
                handoff. Weekly check-ins. A site that's faster, clearer, and more honest
                than what most agencies ship in six months.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* -------- CTA -------- */}
      <section className="ab-cta">
        <div className="ab-container-narrow ab-cta-content">
          <h2>Think we'd <em>work well</em> together?</h2>
          <p>
            Send us a message and tell us about your project. No pressure, no obligation.
            Just a conversation about what you need.
          </p>
          <div className="ab-cta-actions">
            <Link to="/contact" className="ab-btn ab-btn-primary ab-btn-arrow">
              Get in touch
            </Link>
            <Link to="/services" className="ab-btn ab-btn-secondary">
              View services
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default About;